import { ProgramLayout } from '../program-management-actions';
import { ProgramManagementProgram } from '../__generated__/ProgramManagementProgram';
import { ProgramManagementProgramGroup } from '../__generated__/ProgramManagementProgramGroup';

export const buildProgramLayout = (
  programs: ProgramManagementProgram[],
  groups: ProgramManagementProgramGroup[]
): ProgramLayout => {
  const groupIds = new Set(groups.map((group) => group.programGroupId));

  return {
    groups: groups.map((group) => ({
      programGroupId: group.programGroupId,
      name: group.name,
      programIds: programs
        .filter((program) => program.programGroup?.programGroupId === group.programGroupId)
        .map((program) => program.programId),
    })),
    ungroupedProgramIds: programs
      .filter((program) => !program.programGroup || !groupIds.has(program.programGroup.programGroupId))
      .map((program) => program.programId),
  };
};

export const withSuspendedPrograms = (
  layout: ProgramLayout,
  suspendedPrograms: ProgramManagementProgram[]
): ProgramLayout => {
  const suspendedFor = (programGroupId: string | null) =>
    suspendedPrograms
      .filter((program) => (program.programGroup?.programGroupId ?? null) === programGroupId)
      .map((program) => program.programId);

  const keptGroupIds = new Set(layout.groups.map((group) => group.programGroupId));
  const orphanedSuspended = suspendedPrograms
    .filter((program) => program.programGroup && !keptGroupIds.has(program.programGroup.programGroupId))
    .map((program) => program.programId);

  return {
    groups: layout.groups.map((group) => ({
      ...group,
      programIds: [...group.programIds, ...suspendedFor(group.programGroupId)],
    })),
    ungroupedProgramIds: [...layout.ungroupedProgramIds, ...suspendedFor(null), ...orphanedSuspended],
  };
};
